<template>
  <div class="home">
    <div v-if="!isAuthenticated">
      <button @click="login" class="login-button">
        Conectar ao Pipedrive
      </button>
    </div>
    <div v-else>
      <span>Conectado</span>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue'

export default {
  name: 'Home',
  setup() {
    const isAuthenticated = ref(false);
    const currentDealId = ref(null);
    const redirectUri = ref(null);

    onMounted(async () => {
      const token = localStorage.getItem('pipedrive_token');
      isAuthenticated.value = !!token;

      try {
        const ngrokUrl = "https://pipedrive-extensions.franquezatech.com";
        redirectUri.value = `${ngrokUrl}/callback`;
      } catch (error) {
        console.error('Erro ao obter URL do ngrok:', error);
        // Fallback para URL local
        redirectUri.value = process.env.VUE_APP_REDIRECT_URI;
      }
    })

    const login = () => {
      const clientId = process.env.VUE_APP_PIPEDRIVE_CLIENT_ID;
      const scope = 'contacts:read deals:read';

      const authUrl = `https://oauth.pipedrive.com/oauth/authorize?client_id=${clientId}&redirect_uri=${redirectUri.value}&scope=${scope}`;
      window.location.href = authUrl;
    }

    return {
      isAuthenticated,
      currentDealId,
      login
    }
  }
}
</script>

<style scoped>
.login-button {
  padding: 10px 20px;
  background-color: #4CAF50;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
}

.login-button:hover {
  background-color: #45a049;
}
</style>